import { render, staticRenderFns } from "./data-table-create-calculations-settings.vue?vue&type=template&id=1ef1b83d&scoped=true&"
import script from "./data-table-create-calculations-settings.vue?vue&type=script&lang=js&"
export * from "./data-table-create-calculations-settings.vue?vue&type=script&lang=js&"
import style0 from "./data-table-create-calculations-settings.vue?vue&type=style&index=0&id=1ef1b83d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef1b83d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef1b83d')) {
      api.createRecord('1ef1b83d', component.options)
    } else {
      api.reload('1ef1b83d', component.options)
    }
    module.hot.accept("./data-table-create-calculations-settings.vue?vue&type=template&id=1ef1b83d&scoped=true&", function () {
      api.rerender('1ef1b83d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/data-table-create-calculations-settings.vue"
export default component.exports